<i [className]="loading ? 'spinner-border spinner-border-sm' : iconClass"></i>
<span>{{loading ? '' : btnLabel}}</span>
